import Vue from "vue";
import App from "./App.vue";
import router from "@/router/router";
import store from "./store/store";
import "./plugins/element.js";
import "./plugins/myPlugin.js";
import SoundPlugin from "@/plugins/sound";
import "normalize.css";
import "./style/main.scss";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
import "./assets/icon-font/iconfont.css"; // 引入阿里图标矢量库

import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
Vue.use(ViewUI);

import moment from "moment";
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;
Vue.use(SoundPlugin);
new Vue({
  router,
  store,
  echarts,
  render: (h) => h(App),
}).$mount("#app");
